module.exports = __webpack_public_path__ + "static/media/BA.6df2049d.jpg";